import React, { Component, MouseEvent } from 'react';
import { WatchlistType } from '../../../constant/Constants';
import { query } from '@trlogic/client-js';
import _ from 'lodash';
import { apiUrl, InstanceContainer } from '../../../config/binding/InstanceBinding';
import Injectables from '../../../constant/Injectables';
import CustomEmptyComponent from '../../custom/CustomEmptyComponent';
import CustomTable, { CustomColumnProps } from '../../custom/CustomTable';
import { AlertStatus, WatchlistAlertDomains } from '../../../domain/watchlist/WatchlistAlertDomains';
import ItemToolsMenu from '../../ItemToolsMenu';
import CustomPaginator, { CustomPaginatorProps } from '../../custom/CustomPaginator';
import CustomTableContentWrapper from '../../custom/CustomTableContentWrapper';
import moment from 'moment/moment';
import { WatchlistBaseModel, WatchlistEntityRequest, WatchlistIndividualRecord, WatchlistIndividualRequest } from '../../../domain/watchlist/WatchlistDomains';
import { DataTableRowClickEventParams, DataTableSortMeta } from 'primereact/datatable';
import { FormicaProps, withFormica } from '../../../helpers/withFormica';
import NavigationUtil from '../../../util/NavigationUtil';
import { dispatch, RootState, store } from '../../../redux/store';
import { ComponentState, setSelectedItems } from '../../../redux/actions/ComponentActions';
import { connect } from 'react-redux';
import { changePageFilter, clearPage } from '../../../redux/actions/PageActions';
import { ConnectedProps } from 'react-redux/es/exports';
import {
  CustomFilter as FilterType,
  CustomFilterCategorical,
  CustomFilterDateSearch,
  CustomFilterField,
  CustomFilterFields,
  CustomFilterLiteralSearch,
} from '../../../domain/ui/FilterDomains';
import FilterUtil from '../../../util/FilterUtil';
import DefaultFilterUtil from '../../../util/DefaultFilterUtil';
import ServiceContainer from '../../../config/ServiceContainer';
import { ServiceNames } from '../../../constant/ServiceNames';
import WatchlistService from '../../../service/WatchlistService';
import { customConfirm } from '../../custom/CustomPopupConfirm';
import Icon from '../../../icons/Icon';
import MessageUtil from '../../../util/MessageUtil';
import DataType from '../../../constant/DataType';
import WatchlistUtil from '../../../util/WatchlistUtil';
import { AlertExportJob } from '../../../domain/job/JobDomain';
import JobService from '../../../service/JobService';
import HttpMethod from '../../../constant/HttpMethod';
import HttpClient from '../../../gateway/HttpClient';
import GatewayContainer from '../../../config/GatewayContainer';
import GatewayNames from '../../../constant/GatewayNames';
import { Dialog } from 'primereact/dialog';
import FileUploader, { UploadProgress } from '../../sandbox/FileUploader';
import EnvironmentUtil from '../../../util/EnvironmentUtil';
import { AnimatedButton } from '@trlogic/ui-pack';
import ComponentName from '../../../constant/ComponentName';
import { DefaultFilter } from '../../../domain/rbac/RbacDomains';
import ValueUtil from '../../../util/ValueUtil';
import CustomSkeleton from '../../custom/CustomSkeleton';
import Filter = query.Filter;
import empty = query.empty;
import Order = query.Order;
import and = query.and;
import or = query.or;
import eq = query.eq;
import IntervalManager from '../../../util/IntervalManager';
import axios, { Canceler } from 'axios';
import LanguageUtil from '../../../util/LanguageUtil';
import { PageState } from '../../../redux/reducers/PageReducer';

class WatchlistAlertListComponent extends Component<Props, State> {
  public state: State = new State();

  private readonly watchlistService: WatchlistService = ServiceContainer.getInstance().get(ServiceNames.WATCHLIST);
  private readonly jobService: JobService = ServiceContainer.getInstance().get(ServiceNames.JOB);
  private readonly httpClient: HttpClient = GatewayContainer.getInstance().get(GatewayNames.API_CLIENT);
  private readonly intervalManager: IntervalManager = InstanceContainer.get(Injectables.INTERVAL_MANAGER);
  private readonly environmentUtil: EnvironmentUtil = InstanceContainer.get(Injectables.ENVIRONMENT_UTIL);

  private dataCanceler: Canceler | undefined;
  private alertLoadFailed: boolean = false;

  public render() {
    const { kycLogData, loading, currentPage, totalRecord, rows, fileVisible, file, progress, percent, filter } = this.state;
    const {
      component: { selectedComponentIds },
      type,
    } = this.props;
    const isEmpty = totalRecord == 0 && !loading;
    return (
      <div className='w-full h-full flex flex-col px-5'>
        <div className={'flex justify-between bg-white items-center w-full'}>
          <ItemToolsMenu
            views={false}
            importFunc={() => this.setState({ fileVisible: true })}
            exportVisibleAlways={true}
            componentLabel={LanguageUtil.get({ id: 'pages.alert.componentLabel', defaultMessage: 'Alerts' })}
            acceptFunc={(e) => this.closeBulk(e, AlertStatus.NOT_MATCH)}
            rejectFunc={(e) => this.closeBulk(e, AlertStatus.MATCH)}
            acceptLabel={LanguageUtil.get({ id: 'pages.alert.acceptLabel', defaultMessage: 'Not Match' })}
            rejectLabel={LanguageUtil.get({ id: 'pages.alert.rejectLabel', defaultMessage: 'Match' })}
            filter={filter}
            exportFunc={this.exportAlert}
            onChangeFilter={this.onChangeFilter}
            component={ComponentName.WATCHLIST_ALERT}
            componentId={type}
            itemsIsSelected={selectedComponentIds.length > 0}
          />
        </div>
        {isEmpty ? (
          <div className={'h-[100vh] w-full flex items-center justify-center'}>
            <CustomEmptyComponent
              label={LanguageUtil.get({ id: 'pages.alert.emptyComponentLabel', defaultMessage: 'You currently do not have any transactions' })}
            />
          </div>
        ) : loading ? (
          <CustomSkeleton />
        ) : (
          <div>
            <div className={'flex bg-white w-full overflow-y-scroll h-[calc(100vh-400px)] 2xl:h-[calc(100vh-450px)]'}>
              <CustomTable
                columns={this.getColumn()}
                onRowClick={this.onRowClick}
                onSortChange={this.getSort}
                value={kycLogData}
                multiSortMeta={this.getOrder()}
                loading={loading}
                selectionMode={'checkbox'}
                onSelectionChange={this.onSelectionChange}
                scrollable={true}
                scrollHeight={'flex'}
                selection={selectedComponentIds}
              />
            </div>
            <CustomPaginator
              currentPage={currentPage}
              currentRecords={kycLogData.length}
              key='watchlist-alert'
              rows={rows}
              totalRecords={totalRecord}
              loading={loading}
              rowsPerPageOptions={[5, 10, 20, 50, 100]}
              onPageChange={this.onPageChange}
            />
          </div>
        )}
        <Dialog
          header={LanguageUtil.get({ id: 'pages.alert.header', defaultMessage: 'File Upload' })}
          className={'h-1/2 w-1/3'}
          closable={true}
          closeOnEscape={true}
          dismissableMask
          visible={fileVisible}
          onHide={() => this.setState({ fileVisible: false })}
        >
          <div className={'flex flex-col gap-y-2 h-full'}>
            <div className={'flex flex-col gap-y-2 items-center justify-center w-full h-full border-2 border-dashed'}>
              <FileUploader
                acceptedFiles={['text/csv']}
                file={file}
                percent={percent}
                progress={progress}
                onChangeFile={(file) => this.setState({ file })}
                maxBytes={this.environmentUtil.getStorageMaxSize()}
              />
            </div>
            <div className={'flex justify-between'}>
              <div className={'flex gap-x-1 items-center cursor-pointer'} onClick={this.downloadCsvTemplate}>
                <Icon icon={'import'} size={14} color={'#458EF7'} />
                <span className={'text-[#458EF7] text-[12px]'}>
                  {LanguageUtil.get({ id: 'pages.alert.downloadCsv', defaultMessage: 'Download CSV Template' })}
                </span>
              </div>
              <AnimatedButton
                icon={'import'}
                text={LanguageUtil.get({ id: 'common.button.import', defaultMessage: 'Import' })}
                customType={'not-fraud'}
                onClick={this.uploadFile}
              />
            </div>
          </div>
        </Dialog>
      </div>
    );
  }

  public componentDidMount = async () => {
    this.startInterval();
    this.prepareFilterFields();
    dispatch(setSelectedItems([]));
  };

  public componentWillUnmount = async () => {
    const { clearPage } = this.props;
    clearPage();
    this.stopInterval();
  };

  private startInterval = async () => {
    this.intervalManager.clearAlertIntervals();
    this.intervalManager.addAlertInterval(setInterval(async () => await this.onInterval(), 5_000) as any);
    await this.onInterval();
  };

  private onInterval = async () => {
    try {
      const { loading } = this.state;
      const { type } = this.props;

      const token = axios.CancelToken.source();
      this.dataCanceler = token.cancel;

      const _query = this.getQuery();
      const { data, count } = await this.watchlistService.getAlertPageData(type, _query, token.token);
      this.alertLoadFailed = false;
      this.setState({ totalRecord: count });
      if (data.length != this.state.kycLogData.length || !_.isEqual(data, this.state.kycLogData) || data.length == 0 || loading) {
        this.setState({ loading: false, kycLogData: data, totalRecord: count });
      }
    } catch (error: unknown) {
      if (this.isRequestCanceled(error)) {
        return;
      }
      this.setState({ loading: false });
      if (this.alertLoadFailed) {
        return;
      }
      this.alertLoadFailed = true;
      MessageUtil.error({
        summary: LanguageUtil.get({ id: 'pages.alert.alert', defaultMessage: 'Alert' }),
        detail: <div>{LanguageUtil.get({ id: 'pages.alert.loadError', defaultMessage: 'Alert list could not be loaded.' })}</div>,
      });
    }
  };

  private isRequestCanceled = (error: unknown): boolean => {
    if (axios.isCancel(error)) {
      return true;
    }
    if (typeof error != 'object' || error == null || !('code' in error)) {
      return false;
    }
    return (error as { code?: string }).code == 'ERR_CANCELED';
  };

  private restartInterval = async () => {
    this.stopInterval();
    await this.startInterval();
  };

  private stopInterval = () => {
    this.dataCanceler?.();
    this.intervalManager.clearAlertIntervals();
  };

  private getQuery = () => {
    const { rows, currentPage, filter, sorts } = this.state;
    const { type } = this.props;
    const endpoint =
      type == 'General'
        ? `kyc_individual_log_${NavigationUtil.getTenant()},kyc_entity_log_${NavigationUtil.getTenant()}`
        : `kyc_${type.toLowerCase()}_log_${NavigationUtil.getTenant()}`;
    const _sorts: Order[] = sorts.length == 0 ? [{ field: 'results.timestamp', operator: 'DESC' }] : sorts;
    const builder = query.QueryBuilder.select()
      .limit(rows)
      .skip((currentPage - 1) * rows)
      .orderBy(..._sorts)
      .where(filter)
      .from(endpoint);
    return builder.build();
  };

  private formatAlertDate = (value: number | undefined): string => {
    if (value == undefined) {
      return '-';
    }
    return moment(value).format('LLLL');
  };

  private downloadCsvTemplate = () => {
    const { type } = this.props;
    let csvContent = '';

    if (type == 'Individual') {
      csvContent = 'Score;Name;Identification;Citizenship;Date Of Birth;Category\n';
    } else if (type == 'Entity') {
      csvContent = 'Score;Name;Identifier;Date Of Registration;Category\n';
    } else if (type == 'General') {
      csvContent = 'Score;Name;Identification / Identifier;Date Of Birth / Registration;Category\n';
    }

    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');

    if (link.download !== undefined) {
      const url = URL.createObjectURL(blob);
      link.setAttribute('href', url);
      link.setAttribute('download', 'template.csv');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } else {
      MessageUtil.error({
        summary: 'File Uploader',
        detail: <div>{LanguageUtil.get({ id: 'pages.alert.notSupportDownloading', defaultMessage: 'Your browser does not support downloading files.' })}</div>,
      });
    }
  };

  protected prepareFilterFields = async () => {
    const { type, changePageFilter, attributes, user } = this.props;
    const fields: CustomFilterFields[] = await FilterUtil.getWatchlistAlertFields(type);
    const defaultFilter: DefaultFilter | undefined = _.cloneDeep(
      DefaultFilterUtil.find(attributes.filters, {
        component: ComponentName.WATCHLIST_ALERT,
        id: type,
        riskType: user!.activeRiskType,
      }) ??
      DefaultFilterUtil.find(attributes.filters, {
        component: ComponentName.WATCHLIST_ALERT,
        riskType: user!.activeRiskType,
      }),
    );
    const filter: {
      filter: FilterType;
      items: CustomFilterFields[];
    } = store.getState().page.filter;
    filter.items = fields;
    filter.filter.fields = [];
    if (defaultFilter == undefined) {
      filter.filter.fields.push(
        {
          field: `score`,
          label: LanguageUtil.get({ id: 'pages.alert.table.score', defaultMessage: 'Score' }),
          enabled: true,
          search: {
            type: 'LITERAL',
            value: {
              properties: {
                dataType: DataType.NUMBER,
              },
              operator: 'gt',
              value: 0,
            } as CustomFilterLiteralSearch,
          },
        },
        {
          field: `status.keyword`,
          label: LanguageUtil.get({ id: 'pages.alert.table.status', defaultMessage: 'Status' }),
          enabled: true,
          search: {
            type: 'CATEGORICAL',
            value: {
              values: ['IN_REVIEW', 'WAITING_FOR_REVIEW'],
            } as CustomFilterCategorical,
          },
        },
      );
    } else {
      filter.filter = defaultFilter.filter.filter;
      filter.filter.fields?.forEach((savedField: CustomFilterField) => {
        if (savedField.field === "createdAt") {
          savedField.field = "results.timestamp";
        }
      });
    }
    changePageFilter(filter);
    this.setState({ filter: FilterUtil.parse(filter.filter), loading: true }, this.restartInterval);
  };

  private uploadFile = async () => {
    const { file, csvFormat } = this.state;
    const { type } = this.props;
    const endpoint = `${apiUrl}/file/alert/csv`;
    if (file == undefined) return;
    const formData = new FormData();
    formData.append('file', file);
    formData.append('type', type);
    formData.append('semicolon', csvFormat == 'semi colon' ? 'true' : 'false');
    try {
      await this.httpClient.execute(HttpMethod.POST, endpoint, formData, undefined, undefined, (progressEvent: ProgressEvent) => {
        const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        this.setState({ percent: percentCompleted, progress: 'uploading' });
      });
      MessageUtil.success({
        summary: LanguageUtil.get({ id: 'pages.alert.bulkScan', defaultMessage: 'Bulk Scan' }),
        detail: <div>{LanguageUtil.get({ id: 'pages.alert.bulkScanStarted', defaultMessage: 'Alert bulk scan started!' })}</div>,
      });
    } catch (e) {
      MessageUtil.error({
        summary: LanguageUtil.get({ id: 'pages.alert.bulkScan', defaultMessage: 'Bulk Scan' }),
        detail: <div>{LanguageUtil.get({ id: 'pages.alert.bulkScanError', defaultMessage: 'Alert bulk scan error!' })}</div>,
      });
      console.error(e);
    }
  };

  private exportAlert = async () => {
    const {
      component: { selectedComponentIds },
      type,
    } = this.props;
    try {
      const _query = this.getQuery();
      const userFilter = _query.filter;
      if (selectedComponentIds.length > 0) {
        _query.filter = and(_query.filter || empty(), or(...selectedComponentIds.map((id: WatchlistAlertDomains) => eq('id', id.id))));
      }
      const job: AlertExportJob = {
        type: 'ALERT_EXPORT',
        timestamp: moment().valueOf(),
        status: 'PENDING',
        query: _query,
        userFilter,
        extension: 'csv',
        path: '',
        alertType: type,
      };
      await this.jobService.schedule(job);
      MessageUtil.success({
        summary: 'Export',
        detail: <div>{LanguageUtil.get({ id: 'pages.alert.exportJobScheduled', defaultMessage: 'Export job scheduled.' })}</div>,
      });
    } catch (e) {
      console.error(e);
    }
  };

  private onChangeFilter = (filter: Filter) => {
    if (_.isEqual(filter, this.state.filter)) return;
    this.setState({ filter, loading: true }, this.restartInterval);
  };

  private onPageChange = (event: CustomPaginatorProps) => {
    this.setState({ currentPage: event.page, rows: event.rows, loading: true }, this.restartInterval);
  };

  private onSelectionChange = (e: any) => {
    dispatch(setSelectedItems(e.value));
  };

  private getSort = (order: Order[]) => {
    this.setState({ sorts: order, loading: true }, this.restartInterval);
  };

  private getOrder = (): DataTableSortMeta[] => {
    const { sorts } = this.state;
    return sorts.map((s) => {
      return {
        field: s.field,
        order: s.operator == 'ASC' ? 1 : -1,
      } as DataTableSortMeta;
    });
  };

  private onRowClick = async (e: DataTableRowClickEventParams) => {
    const {
      router: { navigate },
      openInNewPage,
    } = this.props;
    const record: WatchlistAlertDomains = e.data;
    const url = await this.calculateUrl(record);
    if (openInNewPage) {
      window.open(`/${NavigationUtil.getTenant()}${url}`, '_blank', 'noopener noreferrer');
    } else {
      navigate(url);
    }
  };

  private calculateUrl = async (record: WatchlistAlertDomains) => {
    const urlParams = new URLSearchParams();
    urlParams.set('id', record.id);
    urlParams.set('type', ValueUtil.convertToStringFirstChar((record as any)?._index.split('_')[1]));
    urlParams.set('name', record?.request?.name || '');
    return `/watchlist-alert/detail/${urlParams.toString()}`;
  };

  private closeBulk = async (e: MouseEvent<HTMLButtonElement>, status: AlertStatus) => {
    const {
      component: { selectedComponentIds },
      type,
    } = this.props;
    const endpoint =
      type == 'General'
        ? `kyc_individual_log_${NavigationUtil.getTenant()},kyc_entity_log_${NavigationUtil.getTenant()}`
        : `kyc_${type.toLowerCase()}_log_${NavigationUtil.getTenant()}`;
    const selectedIds: string[] = selectedComponentIds.map((component: any) => component.id);
    customConfirm({
      target: e.currentTarget,
      rejectIcon: <Icon icon={'close'} className={'text-[#1873D5]'} size={20} />,
      acceptIcon: <Icon icon={'check'} className={'text-white'} size={20} />,
      rejectLabel: LanguageUtil.get({ id: 'common.label.cancel', defaultMessage: 'Cancel' }),
      acceptLabel: LanguageUtil.get({ id: 'common.label.okay', defaultMessage: 'Okay' }),
      message: LanguageUtil.get({ id: 'pages.alert.areYouSureYouWantToClose', defaultMessage: 'Are you sure you want to close ?' }),
      accept: async () => {
        await this.watchlistService
          .closeKycLogBulk(endpoint, selectedIds, status, selectedIds.length == 0 ? this.getQuery() : undefined)
          .then(() => {
            dispatch(setSelectedItems([]));
            MessageUtil.success({
              summary: LanguageUtil.get({ id: 'pages.alert.alert', defaultMessage: 'Alert' }),
              detail: <div>{LanguageUtil.get({ id: 'pages.alert.alertClosed', defaultMessage: 'Alert closed' })}</div>,
            });
          })
          .catch(() => {
            MessageUtil.error({
              summary: LanguageUtil.get({ id: 'pages.alert.alert', defaultMessage: 'Alert' }),
              detail: <div>{LanguageUtil.get({ id: 'pages.alert.alertCloseError', defaultMessage: 'Alert could not be closed.' })}</div>,
            });
          });
      },
    });
  };

  private getFilter(props?: Props | Readonly<Props>) {
    const { page } = props ?? this.props;
    return page.filter;
  }

  private addFilter = async (field: string, value: any, label: string, dataType: DataType, categorical: boolean = false) => {
    const { changePageFilter } = this.props;
    const filter: { filter: FilterType; items: CustomFilterFields[] } = this.getFilter();
    if (categorical) {
      filter.filter.fields.push({
        field: field,
        label: label,
        enabled: true,
        search: {
          type: 'CATEGORICAL',
          value: {
            values: [value],
          } as CustomFilterCategorical,
        },
      });
    } else {
      switch (dataType) {
        case DataType.STRING:
        case DataType.NUMBER:
          filter.filter.fields.push({
            field: field,
            label: label,
            enabled: true,
            search: {
              type: 'LITERAL',
              value: {
                properties: {
                  dataType: dataType,
                },
                operator: 'eq',
                value: value,
              } as CustomFilterLiteralSearch,
            },
          });
          break;
        case DataType.DATE:
          filter.filter.fields.push({
            field: field,
            label: label,
            enabled: true,
            search: {
              type: 'DATE',
              value: {
                startDate: {
                  label: moment(value).format('LLLL'),
                  value: value,
                  type: 'Absolute',
                },
                endDate: {
                  label: moment(value).format('LLLL'),
                  value: value,
                  type: 'Absolute',
                },
              } as CustomFilterDateSearch,
            },
          });
          break;
        case DataType.BOOLEAN:
          await this.addFilter(field, value, label, dataType, true);
          break;
        case DataType.ARRAY:
          filter.filter.fields.push({
            field: field,
            label: label,
            enabled: true,
            search: {
              type: 'CATEGORICAL',
              value: {
                values: value,
              } as CustomFilterCategorical,
            },
          });
          break;
        default:
          return;
      }
    }
    changePageFilter(filter);
    this.onChangeFilter(FilterUtil.parse(filter.filter));
  };

  private getColumn = (): CustomColumnProps[] => {
    const { type } = this.props;
    const columns: CustomColumnProps[] = [
      {
        field: `score`,
        sortField: 'score',
        header: LanguageUtil.get({ id: 'pages.alert.table.score', defaultMessage: 'Score' }),
        alignHeader: 'left',
        columnKey: 'score',
        className: 'min-w-[50px]',
        copyable: true,
        filterable: true,
        addFilter: (record: WatchlistAlertDomains) => {
          this.addFilter('score', record?.score, 'Score', DataType.NUMBER);
        },
        onCopy: (record: WatchlistAlertDomains) => {
          return record?.score.toString();
        },
        body: (record: WatchlistAlertDomains) => {
          return (
            <div
              className={`flex flex-col text-xs 2xl:text-md justify-center items-center ${this.getScoreItem(record?.score)} w-[40px] rounded-[50px] h-[22px]`}
            >
              {record?.score.toString()}
            </div>
          );
        },
      },
      {
        field: 'request.name',
        sortField: 'request.name',
        header: LanguageUtil.get({ id: 'pages.alert.table.name', defaultMessage: 'Name' }),
        alignHeader: 'left',
        columnKey: 'request.name',
        className: 'min-w-[250px]',
        sortable: false,
        copyable: true,
        filterable: true,
        addFilter: (record: WatchlistAlertDomains) => {
          this.addFilter('request.name', record?.request.name, 'Name', DataType.STRING);
        },
        onCopy: (record: WatchlistAlertDomains) => {
          return record?.request.name || 'N/A';
        },
        body: (record: WatchlistAlertDomains) => {
          const result = record.results && record?.results[record.results?.length - 1];
          return (
            <div className={`flex w-full text-xs 2xl:text-md items-center text-f-black-3 justify-start relative group`}>
              <div className={'w-8 h-8 flex items-center justify-center rounded-full bg-[#F4F3FF] mr-1'}>
                {this.getImage(result, ValueUtil.convertToStringFirstChar((record as any)?._index.split('_')[1]))}
              </div>
              {record.request.name || 'N/A'}
            </div>
          );
        },
      },
      {
        field: 'results.record.records.watchlistRecord.categories',
        header: LanguageUtil.get({ id: 'pages.alert.table.category', defaultMessage: 'Category' }),
        alignHeader: 'left',
        columnKey: 'category',
        className: 'min-w-[220px]',
        sortable: false,
        filterable: true,
        addFilter: (record: WatchlistAlertDomains) => {
          this.addFilter('results.record.records.watchlistRecord.categories', this.getCategory(record), 'Category', DataType.ARRAY);
        },
        body: (record: WatchlistAlertDomains) => {
          return (
            <div className={'flex items-center gap-x-2'}>
              {this.getCategory(record)?.map((value: string, index: number) => {
                return (
                  <span
                    key={index}
                    className={`flex text-xs shrink-0 2xl:text-md h-full justify-center px-[16px] py-[3px] items-center rounded-[50px] bg-[#F6F6F9] text-[#4F4F4F]`}
                  >
                    {value}
                  </span>
                );
              })}
            </div>
          );
        },
      },
      {
        field: 'metadata.assignee',
        sortField: 'metadata.assignee',
        header: LanguageUtil.get({ id: 'pages.alert.table.assignee', defaultMessage: 'Assignee' }),
        alignHeader: 'left',
        columnKey: 'metadata.assignee',
        className: 'min-w-[200px]',
        sortable: false,
        copyable: true,
        filterable: true,
        addFilter: (record: WatchlistAlertDomains) => {
          this.addFilter('metadata.assignee', record?.metadata.assignee, 'Assignee', DataType.STRING);
        },
        onCopy: (record: WatchlistAlertDomains) => {
          return record?.metadata.assignee;
        },
        body: (record: WatchlistAlertDomains) => {
          return <div className={`flex w-full text-xs 2xl:text-md items-start text-f-black-3 justify-start relative group`}>{record.metadata.assignee}</div>;
        },
      },
      {
        field: 'results.level',
        sortField: 'level',
        header: 'Level',
        alignHeader: 'left',
        columnKey: 'level',
        className: 'min-w-[150px]',
        sortable: false,
        copyable: true,
        filterable: true,
        addFilter: (record: WatchlistAlertDomains) => {
          this.addFilter('results.level', this.getLevel(record), 'Level', DataType.NUMBER);
        },
        onCopy: (record: WatchlistAlertDomains) => {
          return this.getLevel(record)?.toString() || 'N/A';
        },
        body: (record: WatchlistAlertDomains) => {
          return <div className={`flex w-full text-xs 2xl:text-md items-start text-f-black-3 justify-start relative group`}>{this.getLevelNames(record)}</div>;
        },
      },
      {
        field: 'status',
        sortField: 'status',
        header: LanguageUtil.get({ id: 'pages.alert.table.status', defaultMessage: 'Status' }),
        alignHeader: 'left',
        columnKey: 'status',
        className: 'min-w-[220px]',
        sortable: false,
        copyable: true,
        filterable: true,
        addFilter: (record: WatchlistAlertDomains) => {
          this.addFilter('status', record?.status, 'Status', DataType.STRING);
        },
        onCopy: (record: WatchlistAlertDomains) => {
          return record?.status;
        },
        body: (record: WatchlistAlertDomains) => {
          return (
            <div className={`flex flex-col justify-center items-center text-xs 2xl:text-md rounded-[50px] ${this.getStatusItem(record?.status)} px-2 h-[22px]`}>
              {this.getStatusText(record.status)}
            </div>
          );
        },
      },
      {
        field: 'metadata.reason',
        sortField: 'metadata.reason',
        header: LanguageUtil.get({ id: 'pages.alert.table.reason', defaultMessage: 'Reason' }),
        alignHeader: 'left',
        columnKey: 'metadata.reason',
        className: 'min-w-[250px]',
        sortable: false,
        copyable: true,
        filterable: true,
        addFilter: (record: WatchlistAlertDomains) => {
          this.addFilter('metadata.reason', record.metadata.reason, 'Reason', DataType.STRING);
        },
        onCopy: (record: WatchlistAlertDomains) => {
          return record.metadata.reason;
        },
        body: (record: WatchlistAlertDomains) => {
          return <div className='flex flex-col justify-center items-center text-xs 2xl:text-md rounded-[50px] px-2 h-[22px]'>{record.metadata.reason}</div>;
        },
      },
      {
        field: 'results.timestamp',
        header: LanguageUtil.get({ id: 'pages.alert.table.createdAt', defaultMessage: 'Created At' }),
        alignHeader: 'left',
        columnKey: 'results.timestamp',
        className: 'min-w-[300px]',
        filterable: true,
        copyable: true,
        addFilter: (record: WatchlistAlertDomains) => {
          const createdAt: number | undefined = WatchlistUtil.getLatestResultTimestamp(record.results);
          if (createdAt == undefined) {
            return;
          }
          this.addFilter('results.timestamp', createdAt, 'Created At', DataType.DATE);
        },
        onCopy: (record: WatchlistAlertDomains) => {
          return this.formatAlertDate(WatchlistUtil.getLatestResultTimestamp(record.results));
        },
        body: (record: WatchlistAlertDomains) => {
          return (
            <div className={'flex items-start text-f-black-3 text-xs 2xl:text-md'}>
              <CustomTableContentWrapper text={this.formatAlertDate(WatchlistUtil.getLatestResultTimestamp(record.results))} />
            </div>
          );
        },
      },
      {
        field: 'updatedAt',
        header: LanguageUtil.get({ id: 'pages.alert.table.updatedAt', defaultMessage: 'Updated At' }),
        alignHeader: 'left',
        columnKey: 'updatedAt',
        className: 'min-w-[300px]',
        filterable: true,
        copyable: true,
        addFilter: (record: WatchlistAlertDomains) => {
          if (record.updatedAt == undefined) {
            return;
          }
          this.addFilter('updatedAt', record.updatedAt, 'Updated At', DataType.DATE);
        },
        onCopy: (record: WatchlistAlertDomains) => {
          return this.formatAlertDate(record.updatedAt);
        },
        body: (record: WatchlistAlertDomains) => {
          return (
            <div className={'flex items-start text-f-black-3 text-xs 2xl:text-md'}>
              <CustomTableContentWrapper text={this.formatAlertDate(record.updatedAt)} />
            </div>
          );
        },
      },
    ];
    if (type == 'Individual') {
      columns.splice(
        2,
        0,
        {
          field: 'request.identification',
          sortField: 'request.identification',
          header: LanguageUtil.get({ id: 'pages.alert.table.identification', defaultMessage: 'Identification' }),
          alignHeader: 'left',
          columnKey: 'request.identification',
          className: 'min-w-[150px]',
          sortable: false,
          filterable: true,
          copyable: true,
          addFilter: (record: WatchlistAlertDomains) => {
            this.addFilter('request.identification', (record.request as WatchlistIndividualRequest).identification, 'Identification', DataType.STRING);
          },
          onCopy: (record: WatchlistAlertDomains) => {
            return (record.request as WatchlistIndividualRequest).identification || 'N/A';
          },
          body: (record: WatchlistAlertDomains) => {
            return (
              <div className={`flex w-full text-xs 2xl:text-md items-center text-f-black-3 justify-start relative group`}>
                {(record.request as WatchlistIndividualRequest).identification || 'N/A'}
              </div>
            );
          },
        },
        {
          field: 'request.citizenship',
          sortField: 'request.citizenship',
          header: LanguageUtil.get({ id: 'pages.alert.table.citizenship', defaultMessage: 'Citizenship' }),
          alignHeader: 'left',
          columnKey: 'request.citizenship',
          className: 'min-w-[150px]',
          sortable: false,
          body: (record: WatchlistAlertDomains) => {
            return (
              <div className={`flex w-full text-xs 2xl:text-md items-center text-f-black-3 justify-start relative group`}>
                {(record.request as WatchlistIndividualRequest).citizenship || 'N/A'}
              </div>
            );
          },
        },
        {
          field: 'request.dateOfBirth',
          sortField: 'request.dateOfBirth',
          header: LanguageUtil.get({ id: 'pages.alert.table.dateOfBirth', defaultMessage: 'Date of Birth' }),
          alignHeader: 'left',
          columnKey: 'request.dateOfBirth',
          className: 'min-w-[150px]',
          sortable: false,
          filterable: true,
          copyable: true,
          addFilter: (record: WatchlistAlertDomains) => {
            this.addFilter('request.dateOfBirth', (record.request as WatchlistIndividualRequest).dateOfBirth, 'Date Of Birth', DataType.STRING);
          },
          onCopy: (record: WatchlistAlertDomains) => {
            return (record.request as WatchlistIndividualRequest).dateOfBirth || 'N/A';
          },
          body: (record: WatchlistAlertDomains) => {
            return (
              <div className={`flex w-full text-xs 2xl:text-md items-center text-f-black-3 justify-start relative group`}>
                {(record.request as WatchlistIndividualRequest).dateOfBirth || 'N/A'}
              </div>
            );
          },
        },
      );
    } else if (type == 'Entity') {
      columns.splice(
        2,
        0,
        {
          field: 'request.identifier',
          sortField: 'request.identifier',
          header: LanguageUtil.get({ id: 'pages.alert.table.identifier', defaultMessage: 'Identifier' }),
          alignHeader: 'left',
          columnKey: 'request.identifier',
          className: 'min-w-[150px]',
          sortable: false,
          filterable: true,
          copyable: true,
          addFilter: (record: WatchlistAlertDomains) => {
            this.addFilter('request.identifier', (record.request as WatchlistEntityRequest).identifier, 'Identifier', DataType.STRING);
          },
          onCopy: (record: WatchlistAlertDomains) => {
            return (record.request as WatchlistEntityRequest).identifier || 'N/A';
          },
          body: (record: WatchlistAlertDomains) => {
            return (
              <div className={`flex w-full text-xs 2xl:text-md items-center text-f-black-3 justify-start relative group`}>
                {(record.request as WatchlistEntityRequest).identifier || 'N/A'}
              </div>
            );
          },
        },
        {
          field: 'request.dateOfRegistration',
          sortField: 'request.dateOfRegistration',
          header: LanguageUtil.get({ id: 'pages.alert.table.dateOfRegistration', defaultMessage: 'Date of Registration' }),
          alignHeader: 'left',
          columnKey: 'request.dateOfRegistration',
          className: 'min-w-[150px]',
          sortable: false,
          filterable: true,
          copyable: true,
          addFilter: (record: WatchlistAlertDomains) => {
            this.addFilter(
              'request.dateOfRegistration',
              (record.request as WatchlistEntityRequest).dateOfRegistration,
              'Date Of Registration',
              DataType.STRING,
            );
          },
          onCopy: (record: WatchlistAlertDomains) => {
            return (record.request as WatchlistEntityRequest).dateOfRegistration || 'N/A';
          },
          body: (record: WatchlistAlertDomains) => {
            return (
              <div className={`flex w-full text-xs 2xl:text-md items-center text-f-black-3 justify-start relative group`}>
                {(record.request as WatchlistEntityRequest).dateOfRegistration || 'N/A'}
              </div>
            );
          },
        },
      );
    } else {
      columns.splice(
        2,
        0,
        {
          field: 'request.id',
          sortField: 'request.id',
          header: LanguageUtil.get({ id: 'pages.alert.table.identificationIdentifier', defaultMessage: 'Identification / Identifier' }),
          className: 'min-w-[250px]',
          alignHeader: 'left',
          columnKey: 'request.id',
          sortable: false,
          filterable: true,
          copyable: true,
          addFilter: (record: WatchlistAlertDomains) => {
            const type = (record as any)._index.split('_')[1];
            const data =
              type?.toLowerCase() == 'individual'
                ? (record.request as WatchlistIndividualRequest).identification
                : (record.request as WatchlistEntityRequest).identifier;
            const field = type?.toLowerCase() == 'individual' ? 'request.identification' : 'request.identifier';
            const label = type?.toLowerCase() == 'individual' ? 'Identification' : 'Identifier';
            this.addFilter(field, data, label, DataType.STRING);
          },
          onCopy: (record: WatchlistAlertDomains) => {
            const type = (record as any)._index.split('_')[1];
            const data =
              type?.toLowerCase() == 'individual'
                ? (record.request as WatchlistIndividualRequest).identification
                : (record.request as WatchlistEntityRequest).identifier;
            return data || 'N/A';
          },
          body: (record: WatchlistAlertDomains) => {
            return (
              <div className={`flex w-full text-xs 2xl:text-md items-center text-f-black-3 justify-start relative group`}>
                {ValueUtil.convertToStringFirstChar((record as any)?._index.split('_')[1]) == 'Individual'
                  ? (record.request as WatchlistIndividualRequest).identification || 'N/A'
                  : (record.request as WatchlistEntityRequest).identifier || 'N/A'}
              </div>
            );
          },
        },
        {
          field: 'request.date',
          header: LanguageUtil.get({ id: 'pages.alert.table.dateOfBirthRegistration', defaultMessage: 'Date of Birth Registration' }),
          alignHeader: 'left',
          columnKey: 'request.date',
          className: 'min-w-[250px]',
          sortable: false,
          filterable: true,
          copyable: true,
          addFilter: (record: WatchlistAlertDomains) => {
            const type = (record as any)._index.split('_')[1];
            const data =
              type?.toLowerCase() == 'individual'
                ? (record.request as WatchlistIndividualRequest).dateOfBirth
                : (record.request as WatchlistEntityRequest).dateOfRegistration;
            const field = type?.toLowerCase() == 'individual' ? 'request.dateOfBirth' : 'request.dateOfRegistration';
            const label = type?.toLowerCase() == 'individual' ? 'Date Of Birth' : 'Date Of Registration';
            this.addFilter(field, data, label, DataType.STRING);
          },
          onCopy: (record: WatchlistAlertDomains) => {
            const type = (record as any)._index.split('_')[1];
            const data =
              type?.toLowerCase() == 'individual'
                ? (record.request as WatchlistIndividualRequest).dateOfBirth
                : (record.request as WatchlistEntityRequest).dateOfRegistration;
            return data || 'N/A';
          },
          body: (record: WatchlistAlertDomains) => {
            return (
              <div className={`flex w-full text-xs 2xl:text-md items-center text-f-black-3 justify-start relative group`}>
                {ValueUtil.convertToStringFirstChar((record as any)?._index.split('_')[1]) == 'Individual'
                  ? (record.request as WatchlistIndividualRequest).dateOfBirth || 'N/A'
                  : (record.request as WatchlistEntityRequest).dateOfRegistration || 'N/A'}
              </div>
            );
          },
        },
      );
    }
    return columns;
  };

  private getLevel = (record: WatchlistAlertDomains) => {
    if (record.results && record.results.length > 0) {
      const data = record.results[record.results.length - 1];
      return data?.level;
    }
  };

  private getLevelNames = (record: WatchlistAlertDomains) => {
    const level = this.getLevel(record);
    const type = record.results[record.results.length - 1]?.record?.recordType;
    if (type == 'INDIVIDUAL') {
      switch (level) {
        case 1:
          return 'Identification';
        case 2:
          return 'Name';
        case 3:
          return 'Name, Date of Birth';
        case 4:
          return 'Name, Citizenship';
        case 5:
          return 'Name, Date of Birth, Citizenship';
        default:
          return 'N/A';
      }
    } else if (type == 'ENTITY') {
      switch (level) {
        case 1:
          return 'Identifier';
        case 2:
          return 'Name';
        case 3:
          return 'Name, Date of Registration';
        default:
          return 'N/A';
      }
    } else {
      return 'N/A';
    }
  };

  private getCategory = (record: WatchlistAlertDomains) => {
    if (record == undefined) return;
    const categories: any[] = [];
    record.results &&
      record.results.length > 0 &&
      record.results[record.results.length - 1]?.record?.records?.forEach((response) => {
        categories.push(response.watchlistRecord.categories);
      });
    return _.uniqBy([].concat(...categories));
  };

  private getImage = (record: WatchlistBaseModel, type: string) => {
    if (record) {
      if (type == 'Individual') {
        const images = record?.record?.records?.filter(
          (record) => (record.watchlistRecord as WatchlistIndividualRecord).images && (record.watchlistRecord as WatchlistIndividualRecord).images.length > 0,
        );
        if (images != undefined && images.length > 0) {
          return (
            <img
              src={(images[0].watchlistRecord as WatchlistIndividualRecord).images[0]}
              alt='-'
              className={'w-8 h-8 flex justify-center items-center rounded-[50%] bg-[#EFF2FE] object-cover'}
            />
          );
        }
        return <img src={'/icons/individual.svg'} alt='individual' />;
      } else {
        return <img src={'/icons/entity.svg'} alt='entity' />;
      }
    }
  };

  private getScoreItem = (score: number) => {
    if (score == 0) {
      return 'bg-[#DBF8E5] text-[#3F9E2C]';
    } else if (score > 0 && score < 100) {
      return 'bg-[#FCF1BB] text-[#C57500]';
    } else if (score >= 100) {
      return 'bg-[#FFF1F3] text-[#D2332F]';
    }
  };

  private getStatusItem = (status: AlertStatus | undefined) => {
    switch (status) {
      case AlertStatus.MATCH:
        return 'bg-[#FBE5E4] text-[#C34135]';
      case AlertStatus.NOT_MATCH:
        return 'bg-[#E8FBF1] text-[#027A48]';
      case AlertStatus.IN_REVIEW:
        return 'bg-[#DFEAFD] text-[#175CD3]';
      case AlertStatus.WAITING_FOR_REVIEW:
        return 'bg-[#F6F6F9] text-[#4F4F4F]';
    }
  };

  private getStatusText = (status: AlertStatus | undefined) => {
    if (status == undefined) return 'Unknown';
    switch (status) {
      case AlertStatus.MATCH:
        return LanguageUtil.get({ id: 'pages.alert.matched', defaultMessage: 'Marked as Matched' });
      case AlertStatus.NOT_MATCH:
        return LanguageUtil.get({ id: 'pages.alert.notMatched', defaultMessage: 'Marked as not Matched' });
      case AlertStatus.IN_REVIEW:
        return LanguageUtil.get({ id: 'pages.alert.inReview', defaultMessage: 'In Review' });
      case AlertStatus.WAITING_FOR_REVIEW:
        return LanguageUtil.get({ id: 'pages.alert.waitingForReview', defaultMessage: 'Waiting For Review' });
    }
    return status;
  };
}

interface Props extends FormicaProps, ReduxProps {
  type: WatchlistType;
  openInNewPage?: boolean;
}

const mapStateToProps = (state: RootState) => ({
  user: state.auth.user,
  attributes: state.auth.attributes,
  component: state.component as ComponentState,
  page: state.page as PageState,
});
const connector = connect(mapStateToProps, { clearPage, changePageFilter });
type ReduxProps = ConnectedProps<typeof connector>;

class State {
  filter: Filter = empty();
  loading: boolean = true;
  rows = 10;
  totalRecord = 0;
  currentPage = 1;
  sorts: Order[] = [];
  kycLogData: WatchlistAlertDomains[] = [];
  fileVisible: boolean = false;
  csvFormat: 'comma' | 'semi colon' = 'semi colon';
  percent: number = 0;
  progress: UploadProgress = 'idle';
  file: File | null = null;
}

export default withFormica(connector(WatchlistAlertListComponent));
